// actions.js
import { createAction } from '@reduxjs/toolkit';

export const clearSuggestionsActionType = 'projectBrief/clearSuggestions';

export const clearSuggestions = createAction(clearSuggestionsActionType);
